import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import FooterControl from './FooterControls';
import ReactDOM from 'react-dom';
import Features from './Features';
const Menu = () => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   const [featureMenuList, setfeatureMenuList] = useState([]);
   const [openCloseOnOff, setOpenCloseOnOff] = useState(false);
   const [backliteOnOff, setBackliteOnOff] = useState(false);

   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [uiDataList, setuiDataList] = useState({});
   const [productTitle, setProductTitle] = useState([]);


   let howtoUseD = false;
   var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);
   var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);

            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;

            let feature_list;
            let menuData;
            // console.log(window.LangName)

            let uiData;

            if (setmydata.menus[window.LangName] == undefined) {
               uiData = setmydata.menus.EN[0];

            } else {
               uiData = setmydata.menus[window.LangName][0];
            }
            window.dataUI = uiData;
            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
               // uiData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');

               feature_list = setmydata.menus[window.LangName].filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');


            }
            else {

               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
               // selectedMenu= menuData;
               var mobProducts = menuData[0].items;
               // console.log(menuData)
               feature_list = setmydata.menus.EN.filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
            }

            setMenuList(menuData);
            setuiDataList(uiData);
            //console.log("-----",uiDataList);
            setProductTitle(mobProducts);
            // completeData =menuData;
            setfeatureMenuList(feature_list)

            setbuttonArray([]);
            setbuttonArrayObjectList([])
            // setbuttonArrayObjectListForReset([])
            langTranslationAlignment(menuData);
            menuData.map((menu) => {

               menu.items.map(item => {
                  setbuttonArray((buttonArray) => [...buttonArray, item.id]);

                  setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);

               })
            })
            feature_list.map((menu) => {
               menu.items.map(item => {
                  if (item.id !== undefined) {
                     setbuttonArray((buttonArray) => [...buttonArray, item.id]);
                  }
                  setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);

               })
            })
         });
   }
   const langTranslationAlignment = (menuData) => {
      // console.log('in lang trans')
      if (window.dataUI) {
         // console.log('in lang trans window.ui ')

         document.querySelector('title').innerHTML = window.dataUI.ui.projectTitle;
         document.getElementById('move_text').innerHTML = window.dataUI.ui.move;
         document.getElementById('rotate_text').innerHTML = window.dataUI.ui.rotate;
         document.getElementById('zoom_text').innerHTML = window.dataUI.ui.zoom;
         document.getElementById('exploreButtton').innerHTML = window.dataUI.ui.exploreProductIn3D;




         if (window.dataUI.ui.langcode == "fr") {
            document.getElementById("rotate_text").style.fontSize = '39px';
         }

         if (window.dataUI.ui.langcode == "hu" || window.dataUI.ui.langcode == "it" || window.dataUI.ui.langcode == "fr") {
            // document.getElementById("previousView").style.fontSize = '11px';
            // document.getElementById("resetView").style.fontSize = '11px';
            // document.getElementById("nextView").style.fontSize = '11px';
         }
         if (window.dataUI.ui.langcode == "fr-ca") {
            setTimeout(function () {
               // document.getElementById("previousView").style.fontSize = '11px';
               // document.getElementById("resetView").style.fontSize = '11px';
               // document.getElementById("nextView").style.fontSize = '11px';
            }, 0)
         }
         if (window.dataUI.ui.langcode == "fr-ca" || window.dataUI.ui.langcode == "fr" || window.dataUI.ui.langcode == "de" || window.dataUI.ui.langcode == "it" || window.dataUI.ui.langcode == "nl" || window.dataUI.ui.langcode == "ru" || window.dataUI.ui.langcode == "tr") {
            if (document.getElementById("mobHowToUseText") !== null) {
               document.getElementById("mobHowToUseText").style.fontSize = "30px";
            }
            // if (document.getElementById("move_how_to_use") !== null) {
            //    document.getElementById("move_how_to_use").style.fontSize = "18px";
            // }
            // if (document.getElementById("rotate_how_to_use") !== null) {
            //    document.getElementById("rotate_how_to_use").style.fontSize = "19px";
            // }
            // if (document.getElementById("zoom_how_to_use") !== null) {
            //    document.getElementById("zoom_how_to_use").style.fontSize = "18px";
            // }
         }

         if (window.dataUI.ui.langcode == "it" && !window.mob ) {
            if (document.getElementById("move_how_to_use") !== null) {
               document.getElementById("move_how_to_use").style.fontSize = "19px";
            }
            if (document.getElementById("rotate_how_to_use") !== null) {
               document.getElementById("rotate_how_to_use").style.fontSize = "19px";
            }
            if (document.getElementById("zoom_how_to_use") !== null) {
               document.getElementById("zoom_how_to_use").style.fontSize = "19px";
            }
            setTimeout(() => {
               if (document.querySelector(".subMenuBtn.list#menu_id_pivot") !== null) {
                  document.querySelector(".subMenuBtn.list#menu_id_pivot").style.whiteSpace = "break-spaces";
               }
            }, 100);
         

         }

         if (window.dataUI.ui.langcode == "nl") {
            // document.getElementById("previousView").style.fontSize = '11px';
            // document.getElementById("resetView").style.fontSize = '11px';
            // document.getElementById("nextView").style.fontSize = '11px';
         }

         if (window.dataUI.ui.langcode == "es") {

            // document.getElementById("previousView").style.fontSize = '13px';
            // document.getElementById("resetView").style.fontSize = '13px';
            // document.getElementById("nextView").style.fontSize = '13px';
            document.getElementById("zoom_text").style.display = 'inline-block';
            document.getElementById("zoom_text").style.width = 'max-content';
            document.getElementById("zoom_text").style.fontSize = '34px';
            document.getElementById("move_text").style.fontSize = '34px';
            document.getElementById("rotate_text").style.fontSize = '34px';
         }

         if (window.dataUI.ui.langcode == "pt-br") {
            document.getElementById("nextView").style.fontSize = '13px';
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "de" || window.dataUI.ui.langcode == "pt-br" || window.dataUI.ui.langcode == "ru") {
            document.querySelector(".tooltiptext").style.width = '306px';
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "ja" || window.dataUI.ui.langcode.toLowerCase() === "ru") {
            document.querySelector("#onScreenControl .tooltiptext").style.left = '276px !important';
            document.querySelector(".tooltiptext").style.top = '-19px';
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "hu" || window.dataUI.ui.langcode.toLowerCase() === "sv" || window.dataUI.ui.langcode.toLowerCase() === "nl") {
            document.querySelector(".portraitButtonText").style.fontSize = '11px';
         }

         if (window.dataUI.ui.langcode == "tr") {
            setTimeout(function () {
               document.getElementById("nextView").style.fontSize = '13px';
            }, 0);
         }





         if (window.isipad && window.innerWidth > window.innerHeight) {
            if (window.dataUI.ui.langcode.toLowerCase() == "fr" || window.dataUI.ui.langcode.toLowerCase() == "fr-ca") {
               setTimeout(() => {

                  var nodeList = document.querySelectorAll('.menu .text, .subMenuBtn');

                  for (var i = 0; i < nodeList.length; i++) {
                     nodeList[i].style.fontSize = '14px';
                  }
               }, 100);
            }
         } else {
            if (window.dataUI.ui.langcode.toLowerCase() == "fr" || window.dataUI.ui.langcode.toLowerCase() == "fr-ca") {
               setTimeout(() => {

                  var nodeList = document.querySelectorAll('.menu .text, .subMenuBtn');

                  for (var i = 0; i < nodeList.length; i++) {
                     nodeList[i].style.fontSize = '14px';
                  }
               }, 100);
            }
         }


         if (window.mob) {

            if (window.dataUI.ui.langcode.toLowerCase() == "sv" || window.dataUI.ui.langcode.toLowerCase() == "de" || window.dataUI.ui.langcode.toLowerCase() == "no") {
               setTimeout(() => {
                  var nodeList1 = document.querySelectorAll('.menu .text');

                  for (var i = 0; i < nodeList1.length; i++) {
                     nodeList1[i].style.wordBreak = 'break-word';
                  }
               }, 100);
            }
            // if (window.dataUI.ui.langcode.toLowerCase() == "es" || window.dataUI.ui.langcode.toLowerCase() == "fr" || window.dataUI.ui.langcode.toLowerCase() == "hu" || window.dataUI.ui.langcode.toLowerCase() == "ru" || window.dataUI.ui.langcode.toLowerCase() == "tr") {
            //    document.getElementById("rotate").style.margin = '0';
            //    document.getElementById("loading").style.minWidth = '561px';
            // }

            if (window.dataUI.ui.langcode.toLowerCase() == "nl") {
               setTimeout(() => {

                  var nodeList2 = document.querySelectorAll('.menu .text');

                  for (var i = 0; i < nodeList2.length; i++) {
                     // nodeList1[i].style.fontSize = '10px';
                     nodeList2[i].style.fontSize = '11px';
                  }
               }, 100);
            }

            if (window.dataUI.ui.langcode.toLowerCase() == "de" || window.dataUI.ui.langcode.toLowerCase() == "hu" || window.dataUI.ui.langcode.toLowerCase() == "it" || window.dataUI.ui.langcode.toLowerCase() == "nl" || window.dataUI.ui.langcode.toLowerCase() == "ru" || window.dataUI.ui.langcode.toLowerCase() == "tr") {
               document.querySelector(".closeUseMob").style.top = '-23%';
            }
            if (window.dataUI.ui.langcode.toLowerCase() == "es") {
               document.querySelector(".closeUseMob").style.top = '-18%';
            }
         }

         if (window.dataUI.ui.langcode.toLowerCase() == "de" || window.dataUI.ui.langcode == "nl") {

            setTimeout(function () {
               // document.getElementById("previousView").style.fontSize = '13px';


            }, 0);
         }

         // if (window.dataUI.ui.langcode.toLowerCase() === "fr-ca" || window.dataUI.ui.langcode.toLowerCase() === "no" || window.dataUI.ui.langcode.toLowerCase() === "es") {
         //    setTimeout(function () {
         //       document.querySelector("#rotate_text").style.width = '216px';
         //       document.querySelector("#rotate_text").style.display = 'inline-block';
         //    }, 0);

         // }



         if (window.dataUI.ui.langcode.toLowerCase() === "pl") {
            setTimeout(function () {
               // document.querySelector("#previousView").style.fontSize = '11px';
               // document.querySelector("#resetView").style.fontSize = '12px';
               // document.querySelector("#nextView").style.fontSize = '12px';
            }, 0);

         }

         if (mob && window.innerHeight > window.innerWidth || window.isipad && window.innerHeight > window.innerWidth
         ) {

            if (document.getElementById('mobHowToUseText') !== null) {
               document.getElementById("mobHowToUseText").innerHTML = window.dataUI.ui.howToUSE;
            }

            if (window.dataUI.ui.langcode.toLowerCase() === "es" || window.dataUI.ui.langcode.toLowerCase() === "de") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '36px';
                  document.querySelector("#mobHowToUseText").style.top = '-17%';
                  document.querySelector("#zoom_how_to_use").style.fontSize = '21px';


               }, 0);

            }


            if (window.dataUI.ui.langcode.toLowerCase() === "it") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '36px';


               }, 0);

            }
            if (window.dataUI.ui.langcode.toLowerCase() === "ro") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '39px';
               }, 0);
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "pl" || window.dataUI.ui.langcode.toLowerCase() === "de" || window.dataUI.ui.langcode.toLowerCase() === "es") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.top = '-16%';

               }, 0);

            }


         }

      }


   }
   useEffect(() => {

      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;

   })

   useEffect(() => {
      setTimeout(() => {

         getData();

      }, 1000);

   }, [])

   window.checkWindowSize = function () {

      // console.log('widthUpdate',widthUpdate);
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }

            }
         }
      }

   }
   const howToUSEClick = (e) => {
      if (howtoUseD) {
         // console.log("if.......")
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
         // console.log("else.......")
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";

         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";

         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');

         howtoUseD = true;
      }
   }
   const closeHandle = (e) => {
      e && e.preventDefault();
      // console.log("closeHandle");
      if (document.getElementById('howToUSE')) {
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }

   };

   const accordionMenu = (e) => {
      // console.log("accordionMenu");
      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;

      //   menu camera angle function call
      window.menu_all(myJson.menus.EN, e);

      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';

         }
         // console.log('colapsed');

      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {

               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }
         // }
         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            // console.log("----",accordionContent.offsetHeight)
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }

      }

      if (orentation === 90) {

         closeHandle();
      }


      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         // selectedSubMenu[i].classList.remove('active')
      }
      window.updateSlider();



   }
   const subMenu = (e) => {
      // console.log("subMenu");

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }
   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }
   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         // setAnimValue("On");
         window.Animation = 'on';

      } else {
         // setAnimValue("Off");
         window.Animation = 'off';

      }

   }
   const handleTransitionskeyPress = (e) => {
      // console.log("handleTransitionsKeyPress");
      const isChecked = document.getElementById("animSwitchValue").checked;
      // console.log(isChecked)

      if (isChecked === true) {
         window.Animation = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.Animation = 'on';
         document.getElementById("animSwitchValue").checked = true;

      }

   }
   var animStopped = true;

   const conScreenControlHandler = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === true) {

         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob && !window.isipad) {

            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {

            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {

            // console.log("show");
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }


      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            // console.log('landscape');
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            // console.log("hide");
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {


               animStopped = true;
            }, 200);
         }

      }

   }

   const conScreenControlHandlerkeyPress = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            // console.log('portrait');
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            // console.log("show");
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }


      } else {
         window.animation1SwitchGlobal = 'off';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            // console.log('landscape');

            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            // console.log("hide");
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {

               animStopped = true;
            }, 200);
         }

      }

   }

   // this function is used when we click on sub menu
   const handleMenuClick = (menu_object, e) => {
      // console.log("AnimComplated", window.AnimComplated);
      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      if (!window.AnimComplated) {
         return
      }
      // if (!window.animStoped) return;
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);

      window.currID = menu_object['id'];
      // console.log(window.currID)

      window.execute_all(menu_object);
      setMenuActive(cameraId, cameraType, e);

      window.prevID = menu_object['id'];
      if (orentation === 90) {
         closeHandle();
      }

   }

   const handleAdditionalMenuClick = (menu_object, e) => {
      // console.log("handleAdditionalMenuClick");
      document.getElementById('calloutcanvas').style.opacity = '0'
      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      let new_menu_object = [];
      if (!window.AnimComplated) {
         return
      }
      if (cameraId === 'open_close') {
         if (openCloseOnOff) {
            setOpenCloseOnOff(false);
            new_menu_object = Object.assign({}, menu_object);//copy object by  deep copy method 

            new_menu_object['cameraName'] = menu_object['cameraName'];
            new_menu_object['animvale'] = menu_object['animvale'];

         } else {
            setOpenCloseOnOff(true);
            new_menu_object = Object.assign({}, menu_object);//copy object by  deep copy method 
            new_menu_object['cameraName'] = menu_object['cameraName2'];
            new_menu_object['animvale'] = menu_object['animvale1'];
         }
      } else if (cameraId === "backlit_keyboard") {
         if (backliteOnOff) {
            new_menu_object = Object.assign({}, menu_object);//copy object by  deep copy method 
            new_menu_object['after_cam_state_buttons'] = menu_object['after_cam_state_buttons2'];
            setBackliteOnOff(false)
         } else {
            new_menu_object = Object.assign({}, menu_object)
            setBackliteOnOff(true)
         }
      }

      window.execute_all(new_menu_object);
      setMenuActive(cameraId, cameraType, e);

      window.hidePopUp();
      if (orentation === 90) {

         closeHandle();
      }
   }

   // var MobPopupHideShow = false;
   var menuPopupObject = { name: "" };

   // code for menu active
   const setMenuActive = (menu_id, menu_type, e) => {
      var currentActive;

      if (e != undefined) {
         currentActive = e.target.closest('.list');
      } else {
         currentActive = document.getElementById('menu_id_' + menu_id);
      }
      let currentClass = currentActive.classList[0]
      let preActive = document.querySelector('.' + currentClass + '.active');
      if (preActive != null) {
         preActive.classList.remove('active');
      }
      if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {

         if (preActive?.id == currentActive?.id) {
            setTimeout(() => {
               currentActive.classList.remove('active')

            }, 100);
         } else {
            currentActive.classList.add('active')
         }
      } else {

         currentActive.classList.add('active');
      }

      currentActive.classList.add('active');
      window.selectedConfig.currentProductClick = currentActive.id;
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.selectedButtonType = menu_type;

      window.updateSlider();
   }

   const onPreviousMode = () => {
      window.hidePopUp();
      document.getElementById('calloutcanvas').style.opacity = '0'
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);

      let cameraName;
      window.updateSlider();
      var prevButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton == 'onResetMode' || window.checkedButton == '') {
         prevButton = buttonArray[buttonArray.length - 1];
      } else {

         prevButton = buttonArray[selectedButtonIndex - 1];
      }

      if (prevButton == undefined) { prevButton = buttonArray[buttonArray.length - 1] }

      let result = buttonArrayObjectList.find(object => object.id == prevButton);
      if (window.selectedButtonType !== result['type']) {

         expandMenu(`accordion_${result['type']}`);
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);


      return false;

   }
   const onNextMode = () => {
      window.hidePopUp();
      document.getElementById('calloutcanvas').style.opacity = '0'
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      let cameraName;
      window.updateSlider();
      var nextButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
         nextButton = buttonArray[0];

      } else {
         nextButton = buttonArray[selectedButtonIndex + 1];
      }
      if (nextButton === undefined) { nextButton = buttonArray[0] }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.selectedButtonType !== result['type']) {

         expandMenu(`accordion_${result['type']}`);
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);

      return false;

   }
   const onReset = () => {
      let cameraName;

      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      window.updateSlider();
      if (!window.AnimComplated) {
         return
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '' || window.checkedButton === undefined) {
         // nextButton = buttonArray[0];
         window.GotoPosInTimeNamedValue(window.config.cameraReset);
         //  console.log("2222");
      }
      else {
         nextButton = window.checkedButton;
         //  console.log("3333");
      }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      // console.log(buttonArrayObjectList)
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {

         if (result !== undefined) {
            // console.log("444");
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }


   }
   const expandMenu = (menuId) => {
      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');

         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }

      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {

         document.getElementById(menuId).classList.add('active')

         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }

   }
   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }
   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)

   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   const CanvasResizeFunction = () => {
      // console.log('canvas Resized ')
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90);

      } else {
         setOrentation((item) => {
            return item;
         })
      }
   }
   window.addEventListener('resize', CanvasResizeFunction)

   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...uiDataList.ui }
   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
               <div className='portraitButton' id={arbuttonName} style={arbuttonName === 'btnXR' ? { 'display': 'block' } : {}}>
               <span className='portraitButtonText'> {uiDataList.ui?.arMob}</span>
               </div> 
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  <span className='portraitButtonText'>{uiDataList.ui?.howToUSE}</span>
               </div>

               <div id="howToUseMenu" tabIndex="1" className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => { if (e.key !== 'Enter') { return } howToUSEClick() }}>
                  <div className='icon howtouse'> </div>
                  <div className='text'>{howToUSE !== undefined ? howToUSE : 'How to use'}</div>
               </div>
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandle} />}
               <div className={window.mob || (window.isipad && window.innerWidth < window.innerHeight) ? 'accordionContainer relative d-flex' : 'accordionContainer relative '}>
                  {

                     menuList.map((list) => {

                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick} />}
                           </React.Fragment>
                        )
                     })

                  }

                  {featureMenuList['id'] && <Features featureMenuList={featureMenuList} orentation={orentation} handleAccordian={data1.method} accordionMenu={accordionMenu} handleAdditionalMenuClick={handleAdditionalMenuClick} />}

               </div>
               <div id="menuFooter">
                  {myJson.QRSupport && <div id="qrCode">
                     <img src='images/qrcode.svg' /> <br />
                     <span className='text'> {QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  }
                  <div id="animation">
                     <span>{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={true} />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        <span className=''>{onScreenControls !== undefined ? onScreenControls : 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext !== undefined ? hovertext : 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandle} />
         </div>
      </>
   );
}

export default Menu;